export { default as brandLogo } from './brand-icon.svg'
export { default as bulletPointIcon } from './bullet-point.svg'
export { default as clockIcon } from './clock-icon.svg'
export { default as clockIcon2 } from './clock-active.svg'
export { default as copyIcon } from './copy-button.svg'
export {default as cancelIcon} from './cancel-icon.svg'
export { default as deleteIcon } from './delete-button.svg'
export { default as dislikeIcon } from './dislike-icon.svg'
export {default as dislikeRedIcon} from './dislike-red-icon.svg'
export { default as downArrowIcon } from './down-arrow-icon.svg'
export { default as downloadIcon } from './download-button.svg'
export {default as hoveredDownloadIcon} from './hovered-download-button.svg'
export { default as editIcon } from './edit-button.svg'
export { default as educationIicon } from './education-icon.svg'
export { default as emailIcon } from './email-icon.svg'
export { default as hamburgerIcon } from './hamburger-icon.svg'
export { default as highlightedVoiceIcon } from './highlight-voice-icon.svg'
export { default as hitechIcon } from './hitech-icon.svg'
export { default as leftSectionToggleButton } from './left-section-toggle-button.svg'
export { default as likeIcon } from './like-icon.svg'
export { default as likedIcon } from './liked-icon.svg'
export { default as manageAccountIcon } from './manage-account-icon.svg'
export { default as plusIcon } from './plus-icon.svg'
export { default as powerUtilityIcon } from './power&utility-icon.svg'
export { default as profileIcon } from './profile-icon.svg'
export { default as realstateIcon } from './realstate-icon.svg'
export { default as retailFMCGIcon } from './retail&fmcg-icon.svg'
export { default as saveIcon } from './save-button.svg'
export { default as searchIcon } from './search.svg'
export { default as sendIcon } from './send-button.svg'
export { default as shareIcon } from './share-button.svg'
export { default as signoutIcon } from './signOut-icon.svg'
export { default as speakerIcon } from './speaker-icon.svg'
export { default as hoveredspeakerIcon } from './hovered-speaker-icon.svg'
export { default as toggleButtonLeftArrowIcon } from './toggle-button-left-arrow.svg'
export { default as toggleButtonRightArrowIcon } from './toggle-button-right-arrow2.svg'
export { default as transportationIcon } from './transportation-icon.svg'
export { default as upArrowIcon } from './up-arrow-icon.svg'
export { default as uploadFileIcon } from './upload-file-button.svg'
export { default as voiceFileIcon } from './voice-file-icon.svg'
export {default as voiceIcon} from './voice-icon.svg'
export {default as externalLinkIcon} from './external-link.svg'
export {default as chevronRightIcon} from './chevron-right.svg'
export {default as gmailIcon} from './gmail-icon.svg'
export {default as teamsIcon} from './ms-teams-icon.svg'
export {default as slackIcon} from './slack-icon.svg'
export {default as newProfileIcon} from './new-profile-icon.svg'
export {default as mailicon} from './mailicon.svg'
export {default as eyeIcon} from './eye-icon.svg'
export {default as CloseEyeIcon} from './close-eye-icon.svg'
export {default as imageIcon} from './image-icon.svg'
export {default as generateEmailIcon} from './generate-email.svg'
export {default as generatePostIcon} from './generate-post.svg'
export {default as generateIdeaIcon} from './generate-idea.svg'
export {default as generateArticleIcon} from './generate-artical.svg'
export {default as generateSentimentAnalysisIcon} from './generate-sentiment-analysis.svg'
export {default as generateProductIcon} from './generate-product.svg'
export {default as generationIcon} from './generation-icon.svg'
export {default as revMateIcon} from './rev-mate.svg'
export {default as shopMateIcon} from './shop-mate.svg'
export {default as techMateIcon} from './tech-mate.svg'
export {default as inactiveSendButton} from './inactive-send-button.svg'
 
export {default as homeQmate} from './home-qmate.svg'
export {default as homeDocumate} from './home-documate.svg'
export {default as homeVoice} from './home-voice.svg'
export {default as homeBot} from './home-bot.svg'
export {default as homeLens} from './home-lens.svg'
export {default as searchSend} from './search-send.svg'
export {default as searchMic} from './search-mic.svg'
export {default as searchMicActive} from './search-mic-active.svg'
export {default as uploadIcon} from './upload-icon.svg'
export {default as helperDoc} from './helper-doc.svg'
export {default as helperDots} from './header-dots.svg'
export {default as Dashboard} from './dashboard.svg'
export {default as Admin} from './admin.svg'
export {default as languageIcon} from './language-icon.svg'
export {default as filterIcon} from './filter.svg'
export {default as expandNo} from './expand-no.svg'
export {default as expandYes} from './expand-yes.svg'
export {default as navPrev} from './nav-prev.svg'
export {default as navPrevActive} from './nav-prev-active.svg'
export {default as navNext} from './nav-next.svg'
export {default as navNextActive} from './nav-next-active.svg'
export {default as navClose} from './nav-close.svg'
export {default as chatBotWhite} from './chat-bot-white.svg'
export {default as lensImage} from './lens-image.svg'
export {default as lensSmartBack} from './lens-smart-back.svg'
export {default as lensAi} from './lens-ai.svg'
export {default as imageExpansion} from './image-expand-ai.svg'
export {default as imageExtender} from './image-extender.svg'
export {default as imageCompare} from './image-compare.svg'
export {default as datatableEdit} from './datatable-edit.svg'
export {default as datatableEditHover} from './datatable-edit-hover.svg'
export {default as datatableDelete} from './datatable-delete.svg'
export {default as datatableDeleteHover} from './datatable-delete-hover.svg'
export {default as uploadImage} from './upload-image.svg'
export {default as similarImage} from './similar-image.svg'
export {default as smartBackground} from './smart-background.svg'
export {default as generateInstance} from './generate-instance.svg'
 
export {default as processDownload} from './process-download.svg'
export {default as processNotes} from './process-notes.svg'
export {default as processReplace} from './process-replace.svg'
export {default as processZoom} from './process-zoom.svg'
export {default as processZoomHover} from './process-zoom-hover.svg'
export {default as processExpand} from './process-expand.svg'
export {default as processExpandHover} from './process-expand-hover.svg'
export {default as processImgDoc} from './process-img-doc.svg'
export {default as processImgTag} from './process-img-tag.svg'
export {default as processImgDelete} from './process-img-delete.svg'
export {default as addTagDelete} from './add-tag-delete.svg'
 
export {default as datatableView} from './datatable-view.svg'
export {default as datatableViewHover} from './datatable-view-hover.svg'
export {default as chatBotRefresh} from './chat-bot-refresh.svg'
export {default as closeHistory} from './close-history.svg'
export {default as datatablePending} from './datatable-pending.svg'
export {default as datatableClose} from './datatable-close.svg'
export {default as datatableCloseHover} from './datatable-close-hover.svg'
export {default as datatableCheck} from './datatable-check.svg'
export {default as datatableCheckHover} from './datatable-check-hover.svg'
export {default as infoIcon} from './info-icon.svg'
export {default as plusIconSimple} from './plus-icon-simple.svg'
export {default as deleteDark} from './delete-dark.svg'
 
export {default as adminDashboard} from './admin-dashboard.svg'
export {default as adminDashboardHover} from './admin-dashboard-hover.svg'
export {default as adminAnnouncements} from './admin-announcements.svg'
export {default as adminAnnouncementsHover} from './admin-announcements-hover.svg'
export {default as adminUser} from './admin-user.svg'
export {default as adminUserHover} from './admin-user-hover.svg'
export {default as adminDocApproval} from './admin-doc-approval.svg'
export {default as adminDocApprovalHover} from './admin-doc-approval-hover.svg'
export {default as adminFlag} from './admin-flag.svg'
export {default as adminFlagHover} from './admin-flag-hover.svg'
export {default as adminConfiguration} from './admin-configuration.svg'
export {default as adminConfigurationHover} from './admin-configuration-hover.svg'
export {default as adminBlackListed} from './admin-black-listed.svg'
export {default as adminBlackListedHover} from './admin-black-listed-hover.svg'
export {default as adminVoiceUpload} from './admin-voice-upload.svg'
export {default as adminVoiceUploadHover} from './admin-voice-upload-hover.svg'
export {default as adminDataCollector} from './admin-data-collector.svg'
export {default as adminDataCollectorHover} from './admin-data-collector-hover.svg'
export {default as adminBotConfiguration} from './admin-bot-configuration.svg'
export {default as adminBotConfigurationHover} from './admin-bot-configuration-hover.svg'
export {default as sidebarDrawerArrow} from './sidebar-drawer-arrow.svg'
export {default as InForecast} from './inventory-forecat.svg'
export {default as SalesForecast} from './sales-forecast.svg'
export {default as ImageInfo} from './img-info-icon.svg'
export {default as CompareImageUpload} from './compare-upload.svg'
export {default as LinkIcon} from './link-icon.svg'
export {default as LinkIconWhite} from './link-icon-white.svg'

export {default as StarFill} from './star-fill.svg'
export {default as StarEmplty} from './star-empty.svg'
export {default as ProductAdd} from './product-add.svg'
export {default as InventoryForecastConfiguration} from "./inventory-forecast-configuration.svg"
export {default as InventoryForecastConfigurationHover} from "./inventory-forecast-configuration-hover.svg"
export {default as CloseIcon} from './close-icon.svg'
export {default as ForecastConfigurationIcon} from "./inventory-forecast-configuration.svg"
export {default as ForecastConfigurationHoverIcon} from "./inventory-forecast-configuration-hover.svg"
export {default as ChooseIcon} from "./choose-img.svg"
export { default as DeleteRed } from "./delete-red.svg"
export { default as leftIcon } from "./left-icon.svg"
export { default as rightIcon } from "./right-icon.svg"
